import { render, staticRenderFns } from "./ShipperItemEditDetailsPage.vue?vue&type=template&id=5fadb74b&scoped=true&"
import script from "./ShipperItemEditDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ShipperItemEditDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fadb74b",
  null
  
)

export default component.exports